module.exports = __webpack_public_path__ + "static/img/cdk_modal_img.b608474.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/practiceSystem/cdk_modal_img.png
// module id = FQpM
// module chunks = 23